import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';
import {reducer as formReducer} from 'redux-form';
import {reducer as flashReducer} from 'redux-flash';
import {i18nReducer} from 'react-redux-i18n';
import user from './user';
import layout from './layout';
import workspace from './workspace';
import menu from './menu';
import media from './media';
import contentdefinition from './contentdefinition';
import fielddefinition from './fielddefinition';
import language from './language';
import content from './content';
import block from './block';
import preview from './preview';
import global from './global';

let r = {
    user: user,
    layout: layout,
    form: formReducer,
    flash: flashReducer,
    routing: routerReducer,
    i18n: i18nReducer,
};

r.workspace = workspace;
r.menu = menu;
r.media = media;
r.contentdefinition = contentdefinition;
r.fielddefinition = fielddefinition;
r.language = language;
r.content = content;
r.block = block;
r.preview = preview;
r.global = global;


const reducers = combineReducers(r);

export default reducers;




// WEBPACK FOOTER //
// ./src/store/reducers/index.js